import request from '@/utils/request'


// 查询金币充值模板列表
export function listTemplate(query) {
  return request({
    url: '/coin/template/list',
    method: 'get',
    params: query
  })
}

// 查询金币充值模板分页
export function pageTemplate(query) {
  return request({
    url: '/coin/template/page',
    method: 'get',
    params: query
  })
}

// 查询金币充值模板详细
export function getTemplate(data) {
  return request({
    url: '/coin/template/detail',
    method: 'get',
    params: data
  })
}

// 新增金币充值模板
export function addTemplate(data) {
  return request({
    url: '/coin/template/add',
    method: 'post',
    data: data
  })
}

// 修改金币充值模板
export function updateTemplate(data) {
  return request({
    url: '/coin/template/edit',
    method: 'post',
    data: data
  })
}

// 删除金币充值模板
export function delTemplate(data) {
  return request({
    url: '/coin/template/delete',
    method: 'post',
    data: data
  })
}
